import { Button } from "antd";
import React from "react";
import { useTranslation } from "react-i18next";

interface Props {
    quarter?: string;
    year?: number;
    startOver: () => void;
}

const ReportError = (props: Props) => {

    const { t } = useTranslation();
    return (
        <div className="caculation-progress-wrapper">
            <h4 className="red-text">
                {t("ScenarioFrontier.lbReportError", { quarter: props.quarter, year: props.year })}
            </h4>

            <Button type="primary" shape="round" onClick={props.startOver}>
                {t("ScenarioFrontier.btnStartOver")}
            </Button>

        </div>
    )
}

export default ReportError;